import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
            <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">{t('notFoundTitle')}</h2>
            <p className="text-gray-600 mb-6 text-center max-w-md">{t('notFoundText')}</p>
            <Link
                to="/"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
            >
                {t('backToHome')}
            </Link>
        </div>
    );
};

export default NotFoundPage;
